module.exports = __webpack_public_path__ + "img/w65b.82a1d8d6.jpg";